import React from "react";
import "./services.css";
import { useTranslation } from 'react-i18next';
import BannerComponent from "../../bannerComponent/bannerComponent";


const Services = () => {
  const { t } = useTranslation();

  const servicesData = [
  {
    type: "ia",
    translateTitle1: "HOME_SERVICE_IA_TITLE_1",
    translateTitle2: "HOME_SERVICE_IA_TITLE_2",
    translateText: "HOME_SERVICE_IA_TEXT",
    className: "ia",
    url: "ia",
    featured: true,
    chipText: "TECH_SERVICE_CHIP",
  },
  {
    type: "rpa",
    translateTitle1: "HOME_SERVICE_RPA_TITLE_1",
    translateTitle2: "HOME_SERVICE_RPA_TITLE_2",
    translateText: "HOME_SERVICE_RPA_TEXT",
    className: "rpa",
    url: "rpa",
    chipText: "TECH_SERVICE_CHIP",
  },
  {
    type: "cloud",
    translateTitle1: "HOME_SERVICE_CLOUD_TITLE",
    translateText: "HOME_SERVICE_CLOUD_TEXT",
    className: "cloud",
    url: "cloud",
    chipText: "TECH_SERVICE_CHIP",
  },
  {
    type: "bi",
    translateTitle1: "HOME_SERVICE_BI_TITLE_1",
    translateTitle2: "HOME_SERVICE_BI_TITLE_2",
    translateText: "HOME_SERVICE_BI_TEXT",
    className: "bi",
    url: "bi",
   chipText: "TECH_SERVICE_CHIP",
  },
  {
    type: "web-app-dev",
    translateTitle1: "HOME_SERVICE_WEB_DEV_TITLE_1",
    translateTitle2: "HOME_SERVICE_WEB_DEV_TITLE_2",
    translateText: "HOME_SERVICE_WEB_DEV_TEXT",
    className: "wdad",
    url: "web-app-dev",
    chipText: "TECH_SERVICE_CHIP",
  },
];

  const featuredService = servicesData.find((service) => service.featured);
  const gridServices = servicesData.filter((service) => !service.featured);

  return (
    <div className="services-container" id="services-container">
      <div className="services-layout">
        {featuredService && (
          <BannerComponent
            translateTitle={
              featuredService.translateTitle1
                ? `${t(featuredService.translateTitle1)}${
                    featuredService.type !== "ia" && featuredService.translateTitle2
                      ? ` ${t(featuredService.translateTitle2)}`
                      : ""
                  }`
                : ""
            }
            translateTitle2={
              featuredService.type === "ia" && featuredService.translateTitle2
                ? `${t(featuredService.translateTitle2)}`
                : ""
            }
            translateText={
              featuredService.translateText
                ? `${t(featuredService.translateText)}`
                : ""
            }
            className={`${featuredService.className} featured-card`}
            translateButton={t("HOME_SERVICES_BUTTON")}
            url={featuredService.url}
            chipText={t("TECH_SERVICE_CHIP")}
            featured
          />
        )}

        <div className="services-grid">
          {gridServices.map((service, index) => (
            <BannerComponent
              key={index}
              translateTitle={
                service.translateTitle1
                  ? `${t(service.translateTitle1)}${
                      service.translateTitle2 ? ` ${t(service.translateTitle2)}` : ""
                    }`
                  : ""
              }
              translateText={service.translateText ? `${t(service.translateText)}` : ""}
              className={`${service.className} grid-card`}
              translateButton={t("HOME_SERVICES_BUTTON")}
              url={service.url}
              chipText={t("TECH_SERVICE_CHIP")}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
